/**
 * @module ローディングダイアログ共通コンポーネント
 */
var mixin = {
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.$mount();
    document.body.appendChild(this.$el);
    //this.show = true;
    this.show = false; // #31797の暫定対応
  },
  watch: {
    $browserBack(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.close();
      }
    },
    $route() {
      // ページ遷移した時要素を削除する
      // console.log(new Date(), routeInstance, from);
      this.close();
    },
    $loadingAlsok(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.show = false;
      }
      if (newVal && !oldVal) {
        this.show = true;
      }
      if (!newVal && oldVal === undefined) {
        this.show = false;
      }
    },
  },
  methods: {
    close() {
      this.show = false;
      setTimeout(() => {
        if (document.body.contains(this.$el)) document.body.removeChild(this.$el);
        this.$destroy();
      }, 200);
    },
  },
};

import { VueLoading } from 'vue-loading-template';

export default {
  mixins: [mixin],
  props: {},
  components: {
    VueLoading,
  },
  data() {
    return {};
  },
  /** @type {Methods} */
  methods: {},
};
